import forEach from 'lodash/forEach';
import trim from 'lodash/trim';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';



const URL_SCHEME_HOST = '$1';
const URL_SCHEME_PATH = '$2';
const URL_SCHEME_QUERY = '$3';
const URL_SCHEME_EXP = /^(?:http[s]?:\/\/)?([^/?]*)([^?]*)\??(.*)$/;

//TODO: Should be used URLSearchParams
const Url = function Url (scheme, host, path, query) {
  if (!(this instanceof Url)) {
    return new Url(scheme, host, path, query);
  }

  this._scheme = scheme;
  this._host = host;
  this._path = path;
  this._query = query;
};

Url.parse = function (urlString) {
  if (urlString instanceof this) {
    return urlString;
  }

  urlString = trim(urlString).replace(/#.*$/, '').replace(/\?$/, '').replace(/^\/\//, `${window.location.protocol}//`);

  if (!URL_SCHEME_EXP.test(urlString)) {
    throw new Error('invalid url format');
  }

  const host = urlString.replace(URL_SCHEME_EXP, URL_SCHEME_HOST);
  const path = urlString.replace(URL_SCHEME_EXP, URL_SCHEME_PATH) || '/';
  const scheme = /^https:\/\//.test(urlString) ? 'https://' : 'http://';
  const query = Url.parseQuery(urlString.replace(URL_SCHEME_EXP, URL_SCHEME_QUERY));

  return new this(scheme, host, path, query);
};

Url.prototype = {
  constructor: Url,

  scheme (newValue) {
    if (newValue !== undefined) {
      this._scheme = newValue;
    }

    return this._scheme;
  },

  host (newHost) {
    if (newHost !== undefined) {
      this._host = newHost;
    }

    return this._host;
  },

  path (newPath) {
    if (newPath !== undefined) {
      this._path = newPath;
    }

    return this._path;
  },

  addQuery (queryObj) {
    const query = this._query;

    forEach(queryObj, (v, k) => {
      query[k] = v;
    });

    return this;
  },

  query (newQueryObj) {
    if (newQueryObj !== undefined) {
      this._query = {};
      this.addQuery(newQueryObj);
    }

    return this._query;
  },

  clone () {
    return new Url(this._scheme, this._host, this._path, this._query);
  },

  toString () {
    const query = Url.serializeQuery(this._query);

    return (this._host ? this._scheme : '') + this._host + this._path + (query.length ? `?${query}` : '');
  }
};

Url.parseQuery = (queryStr) => {
  queryStr = queryStr.replace(/^\?/, '');

  const queryArray = queryStr.split('&');
  const query = {};

  forEach(queryArray, (v) => {
    const str = v.split('=');

    query[str[0]] = str[1];
  });

  return query;
};

Url.serializeQuery = (queryProps, addQ = false) => {
  const query = [];

  forEach(queryProps, (v, k) => {
    if (v == null) {
      return;
    }

    if (isArray(v)) {
      forEach(v, (arrV) => {
        if (arrV == null) {
          return;
        }

        query.push(`${k}[]=${arrV}`);
      });
      return;
    }

    if (isObject(v)) {
      v = encodeURIComponent(JSON.stringify(v));
    }

    query.push(`${k}=${v}`);
  });

  return addQ ? `?${query.join('&')}` : query.join('&');
};

export default Url;



// WEBPACK FOOTER //
// ./src/lib/Url.js